import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left", light = false }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
      <Reveal>
        <div className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}>
          <span className="h-px w-10 bg-gold" />
          <span className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold">{eyebrow}</span>
          {align === "center" && <span className="h-px w-10 bg-gold" />}
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className={`mt-5 font-display text-4xl font-bold uppercase leading-[1.02] tracking-wide sm:text-5xl lg:text-6xl ${light ? "text-navy-950" : "text-white"}`}>
          {title}
        </h2>
      </Reveal>
      {sub && (
        <Reveal delay={0.18}>
          <p className={`mt-5 text-base leading-relaxed ${light ? "text-navy-900/70" : "text-slate-400"}`}>{sub}</p>
        </Reveal>
      )}
    </div>
  );
}

export function Counter({ to, suffix = "", className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.4 });
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: EASE,
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);
  return (
    <span ref={ref} className={className}>
      {val}
      {suffix}
    </span>
  );
}
